import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Bell({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Bell</title>
      <path
        d="M5.82474 13.934L5.281 13.4174L5.82474 13.934ZM7.75 9C7.75 6.65279 9.65279 4.75 12 4.75V3.25C8.82436 3.25 6.25 5.82436 6.25 9H7.75ZM7.75 11.7564V9H6.25V11.7564H7.75ZM5.75 16C5.75 15.3992 5.98449 14.8548 6.36847 14.4506L5.281 13.4174C4.64277 14.0892 4.25 14.9995 4.25 16H5.75ZM7 16.25H6V17.75H7V16.25ZM17 16.25H7V17.75H17V16.25ZM18 16.25H17V17.75H18V16.25ZM17.6315 14.4506C18.0155 14.8548 18.25 15.3992 18.25 16H19.75C19.75 14.9995 19.3572 14.0892 18.719 13.4174L17.6315 14.4506ZM16.25 9V11.7564H17.75V9H16.25ZM12 4.75C14.3472 4.75 16.25 6.65279 16.25 9H17.75C17.75 5.82436 15.1756 3.25 12 3.25V4.75ZM18.719 13.4174C18.1171 12.7839 17.75 12.2695 17.75 11.7564H16.25C16.25 12.9385 17.0658 13.8551 17.6315 14.4506L18.719 13.4174ZM4.25 16C4.25 16.9665 5.0335 17.75 6 17.75V16.25C5.86193 16.25 5.75 16.1381 5.75 16H4.25ZM18 17.75C18.9665 17.75 19.75 16.9665 19.75 16H18.25C18.25 16.1381 18.1381 16.25 18 16.25V17.75ZM6.25 11.7564C6.25 12.2695 5.88289 12.7839 5.281 13.4174L6.36847 14.4506C6.93424 13.8551 7.75 12.9385 7.75 11.7564H6.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.7976 19.8767C13.6312 20.2179 13.3712 20.5046 13.048 20.7035C12.7247 20.9023 12.3516 21.0051 11.9721 20.9998C11.5926 20.9945 11.2224 20.8813 10.9049 20.6735C10.5873 20.4657 10.3354 20.1718 10.1786 19.8262"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3V4"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
